// Playground hostnames we trust to send impersonation tokens. Covers the
// default Firebase Hosting host (`playground-<env>-zealth.web.app`), its PR
// preview channels (`--<channel>` suffix), and the custom-domain variant
// (`playground.<env>.zealth.io`, with prod using the bare `playground.zealth.
// io`). Localhost is open to any port so dev setups with non-default vite
// ports still work.
const PLAYGROUND_ORIGIN_PATTERN =
  /^https:\/\/playground-(qa|staging|production)-zealth(--[a-z0-9-]+)?\.web\.app$|^https:\/\/playground(\.(qa|staging))?\.zealth\.io$|^http:\/\/localhost(:\d+)?$/

export const isTrustedPlaygroundOrigin = (origin: string): boolean =>
  PLAYGROUND_ORIGIN_PATTERN.test(origin)
